import type { Asset } from 'contentful';
import { isEntryOrAsset } from '~/utils/guards/isEntryOrAsset';
export function isAsset(value: unknown): value is Asset {
  return isEntryOrAsset(value) && value.sys.type === 'Asset';
}
